import { createSlice } from '@reduxjs/toolkit';
import {
  createAdminCurrency,
  getAdminCurrencies,
  getAdminCurrencyLabel,
  getAdminCurrencyPayments,
  getAdminCurrencyValidator,
  getAdminEditCurrency,
  getCurrencyPaymentsType,
  updateAdminCurrency,
} from './adminCurrency.actions';

const initialState = {
  currencies: [],
  currenciesMeta: {},
  isLoadingCurrencies: false,

  selectedCurrency: {},
  isLoadingCurrency: false,

  validatorOptions: [],
  labelOptions: [],

  payments: [],

  networks: [],

  errors: {},
};

const adminCurrencySlice = createSlice({
  name: 'adminCurrency',
  initialState,
  reducers: {
    setAdminCurrenciesMeta: (state, action) => {
      state.currenciesMeta = action.payload;
    },
    setSelectedCurrency: (state, action) => {
      state.selectedCurrency = action.payload;
    },
    setAdminCurrencyErrors: (state, action) => {
      state.errors = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAdminCurrencies.pending, (state) => {
      state.isLoadingCurrencies = true;
    });
    builder.addCase(getAdminCurrencies.fulfilled, (state, action) => {
      state.currencies = action.payload;
      state.isLoadingCurrencies = false;
    });
    builder.addCase(getAdminCurrencies.rejected, (state) => {
      state.isLoadingCurrencies = false;
    });

    builder.addCase(createAdminCurrency.pending, (state) => {
      state.isLoadingCurrency = true;
    });
    builder.addCase(createAdminCurrency.fulfilled, (state) => {
      state.isLoadingCurrency = false;
    });
    builder.addCase(createAdminCurrency.rejected, (state) => {
      state.isLoadingCurrency = false;
    });

    builder.addCase(getAdminEditCurrency.pending, (state) => {
      state.isLoadingCurrency = true;
    });
    builder.addCase(getAdminEditCurrency.fulfilled, (state, action) => {
      state.selectedCurrency = action.payload;
      state.isLoadingCurrency = false;
    });
    builder.addCase(getAdminEditCurrency.rejected, (state) => {
      state.isLoadingCurrency = false;
    });

    builder.addCase(updateAdminCurrency.pending, (state) => {
      state.isLoadingCurrency = true;
    });
    builder.addCase(updateAdminCurrency.fulfilled, (state) => {
      state.isLoadingCurrency = false;
    });
    builder.addCase(updateAdminCurrency.rejected, (state) => {
      state.isLoadingCurrency = false;
    });

    builder.addCase(getAdminCurrencyValidator.pending, (state) => {
      state.isLoadingCurrency = true;
    });
    builder.addCase(getAdminCurrencyValidator.fulfilled, (state, action) => {
      state.validatorOptions = action.payload;
      state.isLoadingCurrency = false;
    });
    builder.addCase(getAdminCurrencyValidator.rejected, (state) => {
      state.isLoadingCurrency = false;
    });

    builder.addCase(getAdminCurrencyLabel.pending, (state) => {
      state.isLoadingCurrency = true;
    });
    builder.addCase(getAdminCurrencyLabel.fulfilled, (state, action) => {
      state.labelOptions = action.payload;
      state.isLoadingCurrency = false;
    });
    builder.addCase(getAdminCurrencyLabel.rejected, (state) => {
      state.isLoadingCurrency = false;
    });

    builder.addCase(getAdminCurrencyPayments.pending, (state) => {
      state.isLoadingCurrency = true;
    });
    builder.addCase(getAdminCurrencyPayments.fulfilled, (state, action) => {
      state.payments = action.payload;
      state.isLoadingCurrency = false;
    });
    builder.addCase(getAdminCurrencyPayments.rejected, (state) => {
      state.isLoadingCurrency = false;
    });

    builder.addCase(getCurrencyPaymentsType.pending, (state) => {
      state.isLoadingCurrency = true;
    });
    builder.addCase(getCurrencyPaymentsType.fulfilled, (state, action) => {
      state.networks = action.payload;
      state.isLoadingCurrency = false;
    });
    builder.addCase(getCurrencyPaymentsType.rejected, (state) => {
      state.isLoadingCurrency = false;
    });
  },
});

export const { setAdminCurrenciesMeta, setSelectedCurrency, setAdminCurrencyErrors } =
  adminCurrencySlice.actions;

export default adminCurrencySlice.reducer;
